
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://axkwrnkqyuegftszrwne.supabase.co";
const SERVICE_ROLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF4a3dybmtxeXVlZ2Z0c3pyd25lIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTczOTc3OTUzNiwiZXhwIjoyMDU1MzU1NTM2fQ.V5jrh2K1r8VY2LFzzvzyrMzSfhtHFcvIJPGnXWsSr-w";

export const supabaseAdmin = createClient<Database>(
  SUPABASE_URL,
  SERVICE_ROLE_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: false
    }
  }
);
